module.exports = __webpack_public_path__ + "static/media/22.5c711217.jpg";